import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { KoCalendar } from 'packages';
import { add, remove } from 'shared/store/breadcrumbSlice';
import {
  KoButton,
  KoModal,
  KoForm,
  KoLoader,
  KoNano,
  KoToast,
  KoText,
  KoTitle
} from 'packages';
import styles from './calendar.module.scss';
import EventCrud from './curd';
import { EventsAPI } from '../events.service';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

function Meetings() {
  const [currentRecord, setCurrentRecord] = useState();
  const [eventOpen, setEventOpen] = useState(false);
  const [, setModal] = useState(false);
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [meetings, setData] = useState();
  const [isLoading, setLoading] = useState(false);
  const [form] = KoForm.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    getMeetings();
  }, []);

  useEffect(() => {
    dispatch(remove());
    dispatch(add([]));
  }, [dispatch]);

  // const transformMeetings = (meetings = []) =>
  //   meetings.map((meeting) => ({
  //     ...meeting,
  //     start: dayjs.utc(meeting.startTime).local().toDate(),
  //     end: dayjs.utc(meeting.endTime).local().toDate(),
  //     title: meeting.name || '(No Title)'
  //   }));

  const getMeetings = () => {
    setData([]);
    setLoading(true);
    EventsAPI.getMeetings().then(
      (res) => {
        const meetings = res?.meetings || [];
        setData(meetings);
        setEventOpen(false);
        setLoading(false);
      },
      () => setLoading(false)
    );
  };

  const handleEventFinish = (values) => {
    const formData = form.getFieldsValue();

    if (!currentRecord?.meetingId) {
      values.meetingId = KoNano('CAL');
    }

    values.accepted = [];
    values.maybe = [];
    values.notJoining = [];
    values.platform = {
      name: values.meetingVia,
      url: values.url,
      id: KoNano('URL')
    };
    values.agenda = formData.agenda;

    EventsAPI.createMeeting(values, currentRecord?.meetingId)
      .then(() => {
        getMeetings();
        setEventOpen(false);
        KoToast.success(`Meeting ${currentRecord?.meetingId ? 'updated' : 'created'} successfully`);
      })
      .catch((err) => {
        if (err?.error === 'this role does not have sufficient permission') {
          KoToast.error('You do not have sufficient permission');
        }
      });
  };

  const deleteMeeting = () => {
    setLoading(true);
    EventsAPI.deleteMeeting(currentRecord?.meetingId).then(
      () => {
        setDeleteModal(false);
        setEventOpen(false);
        getMeetings();
        KoToast.success('Meeting Deleted Successfully');
      },
      () => setLoading(false)
    );
  };

  const closeModal = () => {
    setCurrentRecord(undefined);
    setEventOpen(false);
    setModal(false);
    setDeleteModal(false);
    form.resetFields();
  };

  const memoizedInitialValues = useMemo(() => currentRecord, [currentRecord]);

  return (
    <>
      <KoTitle text="Calendar" level={3} className={styles.title} />
      {isLoading && <KoLoader />}
      {meetings && <KoCalendar isInfoView={true} onEditMeeting={(record) => {setCurrentRecord(record); setEventOpen(true);}} onDeleteMeeting={(record) => {setCurrentRecord(record);setDeleteModal(true);}} onAddMeetngs={() => setEventOpen(true)} meetings={meetings} />}
      <KoModal
        title={`${currentRecord?.meetingId ? 'Update' : 'Create'} meeting`}
        centered
        open={eventOpen}
        afterClose={closeModal}
        onClose={closeModal}
        handleOk={closeModal}
        width={800}
        height={650}
        footer={[
          <KoButton key="cancel" label="Cancel" onClick={closeModal} />,
          <KoButton
            key="create"
            loading={isLoading}
            type="primary"
            label={currentRecord?.meetingId ? 'Update' : 'Create'}
            onClick={() => form.submit()}
          />
        ]}
      >
        {isLoading && <KoLoader circle={false} />}
        <EventCrud form={form} handleFinish={handleEventFinish} initialValues={memoizedInitialValues} />
      </KoModal>

      <KoModal
        title={`Delete meeting ${currentRecord?.name?.toUpperCase()}`}
        centered
        open={isOpenDelete}
        afterClose={closeModal}
        onClose={closeModal}
        handleOk={closeModal}
        width={580}
        height={450}
        footer={[
          <KoButton key="cancel" label="Cancel" onClick={() => setDeleteModal(false)} />,
          <KoButton
            key="delete"
            loading={isLoading}
            color="danger"
            variant="solid"
            type="primary"
            label="Delete"
            onClick={deleteMeeting}
          />
        ]}
      >
        <div className={styles.suspend}>
          <KoTitle level={5} text="License fees apply to activated users," />
          <KoText text={`granting access to all paid services.`} />
        </div>
      </KoModal>
    </>
  );
}

export default Meetings;
